import React from 'react'

import Image from 'next/image'

import AppearingWrapper from 'Components/Blocks/AppearingWrapper'
import SocialLink from 'Components/Blocks/SocicalLink'
import { HERO_AVATARS_ITEMS } from 'Components/Sections/HomeHero/Title/constants'
import { Button, Row, Text } from 'Components/UI'

import { StripedCircleSvg } from 'Assets/Svg'

import { SocialLinkKindId } from 'Constants/Ids'

import { useResponsiveLayout } from 'Hooks'

import { Avatar, Avatars, Container, Content } from './styles'

type Props = {
  onAction?: () => void
}

function HomeHeroSectionTitle({ onAction }: Props) {
  const { isDesktop } = useResponsiveLayout()

  return (
    <Container>
      <AppearingWrapper centered kind="expand">
        <Content
          flexDirection={[
            'column',
            'column',
            'column',
            'column',
            'column',
            'row',
          ]}
        >
          {StripedCircleSvg()}

          <Text
            as="h1"
            center
            important
            screen14={!isDesktop}
            screen20={isDesktop}
          >
            Networking for Entrepreneurs & Executives
          </Text>
        </Content>
      </AppearingWrapper>

      <Text accent as="h3" bold center mb={5} mt={4} screen40>
        play the Long Game
      </Text>

      <Text bold center important mb={5} screen18>
        Built on Trust. Relationships that last.
      </Text>

      <Text body center mb={8} screen14={!isDesktop} screen20={isDesktop}>
        Emajin the possibilities with exceptional
        <br />
        networking events, speakers and golf.
      </Text>

      <Button large mb={8} onClick={onAction}>
        Apply Now
      </Button>

      <Row alignCenter gap={4} mb={10}>
        <Avatars>
          {HERO_AVATARS_ITEMS.map((item, index) => (
            <Avatar key={item.id} left={index * 30} zIndex={2 - index}>
              <Image
                alt={item.imageAlt}
                height={42}
                src={item.image}
                width={42}
              />
            </Avatar>
          ))}
        </Avatars>

        <Text screen14={!isDesktop} screen20={isDesktop}>
          8800+ Community
          <br />
          Golf’s Business Networking
        </Text>
      </Row>

      <Row gap={6}>
        <SocialLink kind={SocialLinkKindId.Facebook} secondary />

        <SocialLink kind={SocialLinkKindId.Instagram} secondary />

        <SocialLink kind={SocialLinkKindId.LinkedIn} secondary />
      </Row>
    </Container>
  )
}

export default HomeHeroSectionTitle
